import React, { useState, useEffect } from 'react';
import demoPic from '../../Assets/Icons/demoPic.jpg';
import Tilt from 'react-tilt';

const ParticularJourney = ({ data, index }) => {
  return (
    <div className={`container ${index % 2 == 0 ? 'left' : 'right'}`}>
      <Tilt className="Tilt" options={{ max: 25 }}>
        <div class="content">
          <div>
            <div className="type">
              <img src={data.img} />
              <div>{data.type}</div>
            </div>
            <h1 className="heading">{data.heading}</h1>
            <div className="duration">{data.duration}</div>
            <div className="place">{data.place}</div>
            <div className="data">
              {Array.isArray(data.data) ? (
                <>
                  <ul className="list">
                    {data.data.map((listData) => {
                      return <li>{listData}</li>;
                    })}
                  </ul>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </Tilt>
    </div>
  );
};
export default ParticularJourney;
